// Paths a signed-out visitor can open. FlowGuard still wraps some of these
// because they share the catch-all route. They must render, not go to login.
// /trips, /trips/:id, /survey, /pricing, and /pay are not in this list.
// /pricing and /pay have no page, so they keep the login redirect.

const PUBLIC_EXACT_PATHS = new Set([
  "/",
  "/about",
  "/contact",
  "/privacy",
  "/terms",
  "/guides",
  "/login",
  "/signup",
  "/reset-password",
  "/oauth/callback",
  "/stripe/success",
  "/samples",
  "/compare",
  "/use-cases",
  "/llms.txt",
  "/llms-full.txt",
  "/robots.txt",
  "/sitemap.xml",
  "/terms-of-service.pdf",
  "/privacy-policy.pdf",
]);

const PUBLIC_PREFIXES = [
  "/guides/",
  "/samples/",
  "/compare/",
  "/use-cases/",
  "/shared/trips/",
  "/shared/lenses/",
  "/r/",
  "/c/",
  "/password/reset/confirm/",
  "/activate/",
];

export function normalizeAppPath(pathname) {
  const raw = String(pathname || "").trim();
  if (!raw) return "/";
  const path = raw.split("?")[0].split("#")[0];
  if (!path || path === "/") return "/";
  return path.length > 1 && path.endsWith("/") ? path.slice(0, -1) : path;
}

export function isPublicAppPath(pathname) {
  const path = normalizeAppPath(pathname);
  if (!path.startsWith("/")) return false;
  if (PUBLIC_EXACT_PATHS.has(path)) return true;
  return PUBLIC_PREFIXES.some((prefix) => path.startsWith(prefix));
}
